import React, { useState, useRef, forwardRef, useImperativeHandle } from 'react'
import Modal from 'meinian-package/src/component/modal'
import Icon from 'meinian-package/src/component/icon'
import styles from './index.module.less'

export default forwardRef((props, ref) => {
  const [countTime, setCountTime] = useState(3)
  const infoTime = useRef(null)

  const onOk = () => {
    countDown(3, (time) => {
      setCountTime(time)
    }, () => {
      props.onClose()
    })
  }

  const countDown = (time, callback, OnEnd) => {
    let _time = time
    infoTime.current = setInterval(() => {
      _time--
      callback(_time)
      if (_time <= 0) {
        OnEnd()
        clearInterval(infoTime.current)
      }
    }, 1000)
  }

  useImperativeHandle(ref, () => {
    return {
      onOk
    }
  })

  return (<Modal
    hiddenFooter
    style={{ width: '416px', height: '180px', borderRadius: '3px', minHeight: 'unset' }}
    className={styles['mn-info-modal']}
    {...props}
  >
    <div className="mn-info-modal-content">
      <div className="mn-info-modal-header">
        <Icon type="m-xiaoyan_tianchong" className="mn-info-modal-header-icon" />
        <div className="mn-info-modal-header-title">已提交反馈</div>
      </div>
      <div className="mn-info-modal-text">
        我们将尽快处理该标签反馈的问题
      </div>
      <div className="mn-info-modal-close">
        <div className="mn-info-modal-btn" onClick={() => props.onClose()}>关闭({countTime})</div>
      </div>
    </div>
  </Modal>)
})
